import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import _ from 'lodash';
import classes from '../../../_common/Tables/styles.module.scss';
import Loader from '../../../_common/Loader/Loader';
import Pagination from '../../../_common/Pagination/Pagination';

const formatDate = (val) => (val ? moment(val).format('MM/DD/YYYY') : '');
const formatBoolean = (val) => (val ? 'Yes' : 'No');

const formatGender = (val) => {
  const genderLabels = {
    m: 'Male',
    male: 'Male',
    f: 'Female',
    female: 'Female',
  };

  return genderLabels[val.toLowerCase()] || val;
};

export const patientsTableColumns = [
  { label: 'First Name', path: 'firstName' },
  { label: 'Last Name', path: 'lastName' },
  { label: 'Date of Birth', path: 'dob', render: formatDate },
  { label: 'Hub', path: 'hub' },
  { label: 'Gender', path: 'sex', render: formatGender },
  { label: 'Email', path: 'email' },
  { label: 'Phone', path: 'phone' },
  { label: 'Location', path: 'location' },
  { label: 'Address Street', path: 'addressStreet' },
  { label: 'Address City', path: 'addressCity' },
  { label: 'Address State', path: 'addressState' },
  { label: 'Address Zip', path: 'addressZipCode' },
  { label: 'Emergency Contact', path: 'emergencyContact' },
  { label: 'Conditions', path: 'conditions' },
  { label: 'Allergies', path: 'allergies' },
  { label: 'Patient Warning', path: 'patientWarning' },
  { label: 'Prim Ins Plan', path: 'Prim.plan' },
  { label: 'Prim Ins BIN', path: 'Prim.BIN' },
  { label: 'Prim Ins PCN', path: 'Prim.PCN' },
  { label: 'Prim Ins ID', path: 'Prim.insID' },
  { label: 'Prim Ins Group', path: 'Prim.insGroup' },
  { label: 'Prim Ins Type', path: 'Prim.insType' },
  { label: 'Pouch', path: 'pouch', render: formatBoolean },
];

function DashboardPatientsTable({
  data, page, limit, totalPage, onChange,
}) {
  const [loading, setLoading] = useState(false);

  const onChangeLoading = async (path, count) => {
    setLoading(true);
    await onChange(path, count);
    setLoading(false);
  };

  return (
    !data.length && !loading
      ? <div className={classes.notResult}>No Data Found</div>

      : (
        <div className={classes.script_loader_wrapper}>
          { loading && <Loader className={classes.loader_wrapper} />}

          <div className={classes.table_wrapper}>
            <div className={classes.table__border}>
              <table className={classes.table}>

                <thead className={classes.thead}>
                  <tr className={classes.tr}>
                    {patientsTableColumns.map(({ label }) => (
                      <th className={classes.th} key={label}>{label}</th>
                    ))}
                  </tr>
                </thead>

                <tbody className={classes.tbody}>
                  {data.map((d) => (
                    <tr className={classes.tr} key={d.id}>
                      {patientsTableColumns.map(({ label, path, render }, index) => {
                        const value = render ? render(_.get(d, path)) : _.get(d, path);

                        return (
                          <td className={classes.td} key={label}>
                            {index === 0 ? (
                              <NavLink className={classes.patient_transition} to={`/patients/${d.id}`}>
                                {value || '-'}
                              </NavLink>
                            ) : (value || '-')}
                          </td>
                        );
                      })}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <Pagination page={page} limit={limit} totalPage={totalPage} onChange={onChangeLoading} />
        </div>
      )
  );
}

DashboardPatientsTable.propTypes = {
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  totalPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
};

export default DashboardPatientsTable;
